// Colorblind-safe palette, >= 3:1 contrast on both light and dark Telegram surfaces
export const NUTRIENT_COLORS = {
  calories: '#3987e5',
  proteins: '#199e70',
  fats: '#c98500',
  carbs: '#008300',
}

export const NUTRIENT_EMOJIS = {
  calories: '🔥',
  proteins: '🥩',
  fats: '🧈',
  carbs: '🍞',
}

// ghost variants for the "yesterday" comparison line (same hue = same metric identity)
export const NUTRIENT_FADED_COLORS = {
  calories: 'rgba(57, 135, 229, 0.5)',
  proteins: 'rgba(25, 158, 112, 0.5)',
  fats: 'rgba(201, 133, 0, 0.5)',
  carbs: 'rgba(0, 131, 0, 0.5)',
}

// subtle area fills under the main line
export const NUTRIENT_FILL_COLORS = {
  calories: 'rgba(57, 135, 229, 0.12)',
  proteins: 'rgba(25, 158, 112, 0.12)',
  fats: 'rgba(201, 133, 0, 0.12)',
  carbs: 'rgba(0, 131, 0, 0.12)',
}

//
//

// Neutral chart chrome, readable on both light and dark Telegram themes
export const CHART_INK = {
  muted: '#898781',
  grid: 'rgba(137, 135, 129, 0.2)',
}
